<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
                .animation
                    //.animation__guillotine-wrp
                    .animation__guillotine(ref='guillotine')
                        .animation__guillotine-wrp
                    .animation__pig-head-x(ref='pigHeadX')
                        .animation__pig-head(ref='pigHead5060')
                            .animation__pig-head(ref='pigHead1000')
                                .animation__pig-head(ref='pigHead00')
                                    .animation__pig-head-img(ref='pigHeadImg')
                                        img(src='../../assets/img/animated-scroll/pig-head.svg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    data() {
        return {
            innerBlockPosition: 'top',
            isControlScroll: true
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.scrollHandler();
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .fromTo(this.$refs.guillotine, {y: 0}, {ease: 'power2.in', duration: 3, y: '140vh'}, 0)
                .fromTo(this.$refs.pigHead5060, {rotate: 0, x: 0}, {ease: 'none', duration: 1, rotate: 65, x: '50%', transformOrigin: '50% 60%'}, 3)
                .fromTo(this.$refs.pigHead1000, {rotate: 0}, {ease: 'none', duration: 1, rotate: 115, transformOrigin: '100% 2%'}, 4)
                .fromTo(this.$refs.pigHead00, {rotate: 0}, {ease: 'none', duration: 1, rotate: 115, transformOrigin: '0% 2%'}, 5);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 250vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: var(--color-red);
    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }
    &.bottom {
        bottom: 0;
        top: auto;
    }
}
.animation {
    &__guillotine {
        height: 200vh;
        width: 100vw;
        position: absolute;
        bottom: 120%;
        left: 0;
    }
    &__guillotine-wrp {
        background-color: var(--color-black);
        transform: skewY(10deg);
        height: 100%;
    }
    &__pig-head-x {
        position: absolute;
        bottom: 0;
        right: 100%;
        width: calc(25vw + 30vw + 30vh);
        padding-left: 25vw;
        @media (--viewport-tablet) {
            bottom: 28px;
        }
    }
    &__pig-head {
        width: fit-content;
    }
    &__pig-head-img {
        width: fit-content;
    }
}
</style>
